import type { Resource } from '../../';
export const product_sizeChart_category_toddlers: Resource = {"default":"Toddlers"};
